<template>
  <v-toolbar
    app
    fixed
    color='white'
    :clipped-left="$vuetify.breakpoint.mdAndUp"
  >
    <v-toolbar-items>
      <v-tooltip bottom>
        <v-btn flat slot="activator" target="_blank"
          href="https://www.gunghoprinting.com/"
          class="no-padding no-highlight no-caps">
          <img class="toolbar-logo" src="https://assets.gungho.com/gung-ho-logo.png" alt="">
          <v-toolbar-title class="pb-1 hidden-sm-and-down">
            <span class="start">Gung-Ho</span><span class="middle">Printing</span><span class="end">.com</span>
          </v-toolbar-title>
        </v-btn>
        <span>Gung-HoPrinting.com Home Page</span>
      </v-tooltip>
      <v-tooltip bottom class="ml-5">
        <v-btn flat class="icon-only gh-blue hidden-sm-and-down" slot="activator" target="_blank" :href="`${contactUrl}?sub=Technical Support / Report A Bug`">
          <v-icon>mdi-bug</v-icon> Report A Bug
        </v-btn>
        <span>Send Bug Report to Gung-Ho</span>
      </v-tooltip>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <create-menu />
      <v-tooltip bottom>
        <v-btn flat slot="activator" to='/items' class="hidden-sm-and-down">
          Items
        </v-btn>
        <span>Review Items / Reprint One Or More Items</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn flat slot="activator" to='/orders' class="hidden-sm-and-down">
          Orders
        </v-btn>
        <span>Review Orders / Reprint An Entire Order</span>
      </v-tooltip>
      <v-tooltip bottom class="ml-5 hidden-sm-and-down">
        <v-btn flat class="icon-only" slot="activator" target="_blank" :href="helpUrl">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
        <span>Help Topics &amp; Customer Support</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn flat slot="activator" class='icon-only' to='/checkout'>
          <v-badge right overlap class="small">
            <span slot="badge" v-if="cartCount > 0">{{cartCount}}</span>
            <v-icon>mdi-cart</v-icon>
          </v-badge>
        </v-btn>
        <span>Proceed to Checkout</span>
      </v-tooltip>
      <profile-menu></profile-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
  import profileMenu from '@/components/widgets/profile-menu'
  import DialogLoader from '../widgets/dialog-loader'
  import CreateMenu from '../widgets/create-menu'

  export default {
    components: {
      profileMenu,
      dialogLoader: DialogLoader,
      createMenu: CreateMenu
    },

    beforeMount () {
      this.$store.dispatch('loadCart')
    },

    computed: {
      contactUrl () {
        return process.env.CONTACT_URL
      },

      helpUrl () {
        return process.env.HELP_URL
      },

      cartCount () {
        if (!this.$store.state.cart) return 0
        if (!this.$store.state.cart.cart_items) return 0
        return this.$store.state.cart.cart_items.length
      },

      hasProxy () {
        if (!this.$store.state.user.features) return false
        return this.$store.getters.features.includes('proxy')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// header-menu.vue?215d50da